import "./SideBarItem.css";
import React, { useState } from "react";
import { Link, useLocation } from "react-router-dom";

const SideBarItem = ({
  item,
  keyIndex,
  IsChildActive,
  IsActive,
  setIndexGlobal,
  indexGlobal,
  setIndexGlobalOpen,
  indexGlobalOpen,
}) => {
  //  IsChildActive for subpath like add etc
  // IsChildActive for routes that have child

  const [isSubChildActive, setIsSubChildActive] = useState(false);
  const [Open, setOpen] = useState(false);

  const path = useLocation().pathname;

  let isSubItemActive = false;

  if (item.children) {
    return (
      <li
        className={`submenu ${
          indexGlobal === keyIndex || IsChildActive || IsActive ? "active" : ""
        }`}
        key={keyIndex}
      >
        <Link
          className={`subdrop ${Open ? "active " : ""}`}
          onClick={() => {
            setOpen(!Open);
          }}
        >
          {item.icon}
          <span>{item.title}</span>
          <span className="menu-arrow"></span>
        </Link>

        {Open && (
          <ul id="sidebar-submenu" className={`${Open ? "d-block" : "d-none"}`}>
            {item.children.map((subMenu, key2) => {
              isSubItemActive = subMenu.path === path;
              return (
                <li
                  key={key2}
                  className={`submenu-item ${
                    isSubItemActive ? " subitem-active" : ""
                  }`}
                >
                  <Link
                    to={subMenu.path}
                    onClick={() => {
                      setIndexGlobal(keyIndex);
                      setIsSubChildActive(true);
                    }}
                  >
                    {subMenu.title}
                  </Link>
                </li>
              );
            })}
          </ul>
        )}
      </li>
    );
  } else {
    return (
      <li
        key={keyIndex}
        className={`${IsChildActive || IsActive ? "active" : ""}`}
      >
        <Link
          to={item.path}
          onClick={() => {
            setIndexGlobal(-1);
            setIsSubChildActive(false);
          }}
        >
          {item.icon}
          <span> {item.title}</span>
        </Link>
      </li>
    );
  }
};

export default SideBarItem;
